export default __webpack_public_path__ + "static/0151-9bdb51e8e334c04cf206d28180fc112a.png";